//REACT
import React from 'react';
import { render } from 'react-dom'
//REACT-REDUX
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
//import logger from 'redux-logger'
import reducers from './reducers'
//REACT ROUTER
import { BrowserRouter as Router,Switch, Route,Redirect} from 'react-router-dom'
//OWN COMPONENTS
import AuthorizedRoute from './components/Route/AuthorizedRoute'
import Login from './components/Route/IdentityManager'
import {Dashboard, Map, Admin, error404, error401} from './components/Route'

import { composeWithDevTools } from 'redux-devtools-extension';


// TEST
import ws_test from './ws_test';

let store ='';

if (process.env.NODE_ENV === 'production') {
     store = createStore(
        reducers,
        applyMiddleware(thunk)
    )
}else{
     //store = createStore(
     //   reducers,
     //   applyMiddleware(thunk, logger)
    //)
     store = createStore(
         reducers, composeWithDevTools(
             applyMiddleware(thunk)
         ));
}

render(
    <Provider store={store}>
        <Router >
            <Switch>
                <Route path="/test" component={ws_test}/>
                <Route path="/404" component={error404}/>
                <Route path="/401" component={error401}/>
                <Route path="/login" component={Login}/>
                <AuthorizedRoute path="/dashboard" component={Dashboard}/>
                <AuthorizedRoute path="/organization" component={Dashboard}/>
                <AuthorizedRoute path="/stations" component={Dashboard}/>
                <AuthorizedRoute path="/account" component={Dashboard}/>
                <AuthorizedRoute path="/map" component={Map}/>
                <AuthorizedRoute admin path="/admin" component={Admin}/>
                <Redirect exact from="/" to="/dashboard"/>
                <Route path='*' component={error404} />
            </Switch>
        </Router>
    </Provider>,
    document.getElementById('mymap')
);


// WEBPACK FOOTER //
// ./src/index.js